var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhoneBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPhoneBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.2   0 0 0 0 0.2   0 0 0 0 0.2  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Platinum-upgrade",
    transform: "translate(-9.000000, -1224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 1009.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPhoneBlack",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.7331344,13.2101912 C16.4063718,12.8054871 17.2788609,13.0018582 17.7137384,13.6560053 L17.7137384,13.6560053 L21.0884697,18.7164422 C21.5128011,19.3588227 21.372822,20.2193987 20.7668156,20.6942145 L20.7668156,20.6942145 L18.8728258,22.1678276 C18.6229433,22.3587792 18.5518552,22.7046013 18.7061887,22.9786029 L18.7061887,22.9786029 L18.8599362,23.2590005 C19.3665853,24.1868075 19.9986151,25.3442348 22.3288494,27.6752992 C24.6590838,30.0063636 25.8156323,30.6371239 26.7451482,31.143773 L26.7451482,31.143773 L27.0255458,31.2983506 C27.2995962,31.4505846 27.6439536,31.3781294 27.8333916,31.1283446 L27.8333916,31.1283446 L29.3074442,29.2330853 C29.782211,28.6268348 30.6430312,28.487051 31.2852164,28.9118707 L31.2852164,28.9118707 L36.3456533,32.286602 C37.0000934,32.7217236 37.1963668,33.5947498 36.7910768,34.2681336 L36.7910768,34.2681336 L35.5186684,36.3829555 C35.1280256,37.0480393 34.4948729,37.535891 33.7521586,37.7440776 C33.1138305,37.9166713 32.4551916,38.0026996 31.7939649,37.9999355 C28.9208538,37.9999355 24.7407668,36.4899782 19.1257842,30.875435 C12.0671665,23.8159874 11.4939211,19.0242791 12.255921,16.24784 C12.4643517,15.5052721 12.9521546,14.8722171 13.6170431,14.4813302 L13.6170431,14.4813302 Z",
    id: "Shape",
    fill: "#333333",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneBlack);
export default __webpack_public_path__ + "static/media/icPhoneBlack.6ac5548c898bbb5cecf4b130a602a0d3.svg";
export { ForwardRef as ReactComponent };